import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Label,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ProgressBar,
} from 'mw-style-react';
import { GET_REF_BOOK_USAGE } from '@control-front-end/common/constants/refBooks';
import UsersAvatars from '@control-front-end/common/components/UsersAvatars';
import useIntl from 'useIntl';
import mes from './intl';
import '../../CreateRefBook.scss';

const RefBookUsage = ({ refBookId }) => {
  const t = useIntl();
  const dispatch = useDispatch();
  const [isLoaded, setLoading] = useState(true);
  const [bookUsage, setBookUsage] = useState(null);

  useEffect(() => {
    setLoading(false);
    dispatch({
      type: GET_REF_BOOK_USAGE.REQUEST,
      payload: refBookId,
      callback: (data) => {
        setBookUsage(data);
        setLoading(true);
      },
    });
  }, []);

  const renderAccessInfo = (access, ownerId) => {
    const users = access
      ? access.filter((u) => u.userId !== ownerId && u.userType !== 'system')
      : [];
    return users.length ? <UsersAvatars size="small" users={users} /> : '-';
  };

  const renderTemplatesItem = (tpl) => {
    const { id, title, access, ownerId, ownerName, ownerAvatar } = tpl;
    return (
      <TableRow key={id} styleName="table__row" rowSize="small">
        <TableCell styleName="table__cell name">{title}</TableCell>
        <TableCell styleName="table__cell access">
          {renderAccessInfo(access, ownerId)}
        </TableCell>
        <TableCell styleName="table__cell owner">
          <UsersAvatars
            size="small"
            users={[{ userId: ownerId, name: ownerName, avatar: ownerAvatar }]}
          />
        </TableCell>
      </TableRow>
    );
  };

  const renderLoader = () => (
    <div styleName="content__loader">
      <ProgressBar type="circle" size="large" />
    </div>
  );

  const renderContent = () => {
    const tplCount = bookUsage.length;
    const label = tplCount
      ? t(mes.bookUsageInfo, { count: tplCount })
      : t(mes.bookNotUsed);
    return (
      <div styleName="row">
        <div styleName="row__label">
          <Label fontWeight="semibold" value={label} />
        </div>
        {tplCount ? (
          <Table paddingSize="small" styleName="table">
            <TableHead fixed={true}>
              <TableRow styleName="table__row" rowSize="small">
                <TableCell styleName="table__cell name">
                  {t(mes.name)}
                </TableCell>
                <TableCell styleName="table__cell access">
                  {t(mes.sharedWith)}
                </TableCell>
                <TableCell styleName="table__cell owner">
                  {t(mes.owner)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bookUsage.map((tpl) => renderTemplatesItem(tpl))}
            </TableBody>
          </Table>
        ) : null}
      </div>
    );
  };

  return isLoaded && bookUsage ? renderContent() : renderLoader();
};

RefBookUsage.propTypes = {
  refBookId: PropTypes.number.isRequired,
};

export default RefBookUsage;
